/**
 * @generated SignedSource<<d784eb860185d4b08b1302ade1449722>>
 * @relayHash 22f28acc9385c908327e5b01e2b27afe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39cadc430a180014c94dc1121935de9bee2e9720e8621e4d264203bd6e30f60e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type connectTeamToContainerMutation$variables = {
  containerId: string;
  teamId: string;
};
export type connectTeamToContainerMutation$data = {
  readonly graphStore: {
    readonly createTeamConnectedToContainer: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type connectTeamToContainerMutation = {
  response: connectTeamToContainerMutation$data;
  variables: connectTeamToContainerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "from",
                "variableName": "teamId"
              },
              {
                "kind": "Variable",
                "name": "to",
                "variableName": "containerId"
              }
            ],
            "kind": "ObjectValue",
            "name": "relationships.0"
          }
        ],
        "kind": "ListValue",
        "name": "relationships"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "success"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "connectTeamToContainerMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreCreateTeamConnectedToContainerPayload",
            "kind": "LinkedField",
            "name": "createTeamConnectedToContainer",
            "plural": false,
            "selections": [
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "connectTeamToContainerMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreCreateTeamConnectedToContainerPayload",
            "kind": "LinkedField",
            "name": "createTeamConnectedToContainer",
            "plural": false,
            "selections": [
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "39cadc430a180014c94dc1121935de9bee2e9720e8621e4d264203bd6e30f60e",
    "metadata": {},
    "name": "connectTeamToContainerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "475ac60a1fe98405bcd37888971bc339";

export default node;
